import React from 'react';
import { mergeStyles } from '@fluentui/react';
import { StackShim as Stack } from '@fluentui/react-migration-v8-v9';

interface IStackColumnProps {
  minWidth?: string;
  maxWidth?: string;
  children: React.ReactNode;
}

const StackColumn = ({ children, minWidth, maxWidth }: IStackColumnProps): JSX.Element => {
  const stackColumnClassName = mergeStyles({
    flexBasis: 0,
    minWidth: minWidth || '250px',
    maxWidth,
  });

  return (
    <Stack grow={1} tokens={{ childrenGap: 15 }} className={stackColumnClassName}>
      {children}
    </Stack>
  );
};

export default StackColumn;
